import type React from "react";
import { PATH_SUPERADMIN } from "src/routesConstants";

import type { UserBase } from "src/types/user";

import { LinkWithIcon } from "./LinkWithIcon";

interface UserLinkProps {
    user: UserBase;
    Icon?: JSX.Element;
    className?: string;
}

export const UserLink: React.FC<UserLinkProps> = ({ user, Icon, className }): JSX.Element => (
    <LinkWithIcon to={`${PATH_SUPERADMIN}/user/${user.id}`} Icon={Icon} className={className}>
        {`${user.firstName} ${user.lastName}`}
    </LinkWithIcon>
);
